import { type Box, type GlyphMetrics, layoutTrace, traceFontSize } from "@ai-teach/canvas-core";

/** Andika is a literacy face: its a/g are single-storey, matching how children are taught to write them. */
export const WRITING_FONT = "'Andika', 'Comic Sans MS', sans-serif";

const canvasMetrics = (fontSize: number): GlyphMetrics | null => {
  const ctx = document.createElement("canvas").getContext("2d");
  if (!ctx) return null;

  ctx.font = `700 ${fontSize}px ${WRITING_FONT}`;
  return {
    advance: (text) => ctx.measureText(text).width,
    inkBounds: (char) => {
      const metrics = ctx.measureText(char);
      return {
        left: -metrics.actualBoundingBoxLeft,
        right: metrics.actualBoundingBoxRight,
        top: -metrics.actualBoundingBoxAscent,
        bottom: metrics.actualBoundingBoxDescent,
      };
    },
  };
};

export const layoutWord = (text: string, box: Box) => {
  const fontSize = traceFontSize(box);
  const metrics = canvasMetrics(fontSize);
  return metrics && layoutTrace(text, box, fontSize, metrics);
};
